<template>
  <ul class="phone-nav">
    <li class="index" :class="{'active':active=='index'}">首页</li>
    <li class="product" :class="{'active':active=='product'}">产品</li>
    <li class="marketing" v-if="!($units.isOkBao() || $units.isOkTX())" :class="{'active':active=='marketing'}">展业</li>
    <li class="order" v-if="!($units.isOkBao() || $units.isOkTX())" :class="{'active':active=='order'}">订单</li>
    <li class="marketing" v-if="$units.isOkBao() || $units.isOkTX()" :class="{'active':active=='marketing'}">攻略</li>
    <!-- <li class="cloud" :class="{'active':active=='cloud'}">云学院</li> -->
    <li class="my" :class="{'active':active=='my'}">我的</li>
  </ul>
</template>

<script>
export default {
  components: {},
  mixins:[],
  props: ['active'],
  data() {
    return {
      list:[],
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
  },

};
</script>
<style lang="scss" scoped>
@import "./phoneNav.scss";
</style>
